'use client';
import React, { useEffect, useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';
import {
  AreaChart,
  Area,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell } from
'recharts';

const tripData = [
{ day: 'Mon', trips: 4200, revenue: 126000 },
{ day: 'Tue', trips: 5100, revenue: 153000 },
{ day: 'Wed', trips: 4800, revenue: 144000 },
{ day: 'Thu', trips: 5600, revenue: 168000 },
{ day: 'Fri', trips: 6200, revenue: 186000 },
{ day: 'Sat', trips: 7100, revenue: 213000 },
{ day: 'Sun', trips: 5400, revenue: 162000 }];


const monthlyData = [
{ month: 'Oct', trips: 118000 },
{ month: 'Nov', trips: 127000 },
{ month: 'Dec', trips: 134000 },
{ month: 'Jan', trips: 141000 },
{ month: 'Feb', trips: 138000 },
{ month: 'Mar', trips: 152000 }];


const pieData = [
{ name: 'Fleet', value: 45, color: '#0066FF' },
{ name: 'Courier', value: 32, color: '#075DDF' },
{ name: 'Logistics', value: 23, color: '#3B82F6' }];


const drivers = [
{ name: 'Suresh Kumar', trips: 28, rating: 4.9, status: 'active', vehicle: 'KA 01 AB 1234', avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_16972ee40-1773120700276.png", alt: 'Indian male driver smiling' },
{ name: 'Ravi Patel', trips: 24, rating: 4.8, status: 'active', vehicle: 'KA 02 CD 5678', avatar: 'https://img.rocket.new/generatedImages/rocket_gen_img_1b02b7bf9-1763301533769.png', alt: 'Indian male professional headshot' },
{ name: 'Anand Nair', trips: 19, rating: 4.7, status: 'break', vehicle: 'KA 03 EF 9012', avatar: 'https://img.rocket.new/generatedImages/rocket_gen_img_1b346009c-1763295401809.png', alt: 'Young Indian man neutral expression' },
{ name: 'Deepak Sharma', trips: 22, rating: 4.9, status: 'active', vehicle: 'KA 04 GH 3456', avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1dc78c630-1763296946525.png", alt: 'Middle-aged man smiling headshot' },
{ name: 'Kiran Reddy', trips: 17, rating: 4.6, status: 'offline', vehicle: 'KA 05 IJ 7890', avatar: 'https://img.rocket.new/generatedImages/rocket_gen_img_1332a1d79-1772140965034.png', alt: 'Professional man in shirt' }];


const liveTrips = [
{ id: '#TRP-8821', from: 'Koramangala', to: 'Whitefield', driver: 'Suresh Kumar', eta: '12 min', status: 'In Transit' },
{ id: '#TRP-8820', from: 'MG Road', to: 'Electronic City', driver: 'Ravi Patel', eta: '8 min', status: 'Arriving' },
{ id: '#TRP-8819', from: 'Indiranagar', to: 'HSR Layout', driver: 'Deepak Sharma', eta: '18 min', status: 'In Transit' },
{ id: '#TRP-8818', from: 'Marathahalli', to: 'Bellandur', driver: 'Anand Nair', eta: '5 min', status: 'Arriving' }];


const fleetStatus = [
{ label: 'Active', count: 38, color: '#10B981', bg: 'rgba(16,185,129,0.1)' },
{ label: 'On Break', count: 12, color: '#F59E0B', bg: 'rgba(245,158,11,0.1)' },
{ label: 'Offline', count: 8, color: '#94A3B8', bg: 'rgba(148,163,184,0.1)' },
{ label: 'Maintenance', count: 4, color: '#EF4444', bg: 'rgba(239,68,68,0.1)' }];


const kpiCards = [
{ label: 'Total Trips Today', value: '1,284', change: '+8.2%', up: true, icon: 'TruckIcon', color: '#0066FF' },
{ label: 'Revenue Today', value: '₹3,85,200', change: '+12.4%', up: true, icon: 'CurrencyRupeeIcon', color: '#075DDF' },
{ label: 'Active Drivers', value: '38', change: '+3', up: true, icon: 'UserGroupIcon', color: '#075DDF' },
{ label: 'Avg Trip Time', value: '24 min', change: '-2 min', up: true, icon: 'ClockIcon', color: '#0066FF' }];


const vehicleDots = [
{ x: '22%', y: '35%' }, { x: '45%', y: '55%' }, { x: '68%', y: '28%' },
{ x: '33%', y: '72%' }, { x: '78%', y: '62%' }, { x: '55%', y: '42%' },
{ x: '15%', y: '60%' }, { x: '85%', y: '38%' }];


function DriverTable() {
  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[540px]">
        <thead>
          <tr className="border-b border-[rgba(15,23,42,0.06)]">
            {['Driver', 'Vehicle', 'Trips Today', 'Rating', 'Status'].map((h) =>
            <th key={h} className="text-left text-[11px] font-semibold text-[#64748B] uppercase tracking-wide pb-3 pr-4">{h}</th>
            )}
          </tr>
        </thead>
        <tbody>
          {drivers.map((d, i) =>
          <tr key={d.name} className="border-b border-[rgba(15,23,42,0.04)] hover:bg-[#F5F5F5] transition-colors">
              <td className="py-3 pr-4">
                <div className="flex items-center gap-3">
                  <div className="relative flex-shrink-0">
                    <AppImage src={d.avatar} alt={d.alt} width={32} height={32} className="w-8 h-8 rounded-full object-cover" />
                    {i === 0 &&
                  <div className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-yellow-400 flex items-center justify-center">
                        <span className="text-[8px] font-bold text-yellow-900">1</span>
                      </div>
                  }
                  </div>
                  <span className="text-sm font-medium text-[#0F172A]">{d.name}</span>
                </div>
              </td>
              <td className="py-3 pr-4"><span className="font-mono-custom text-xs text-[#64748B]">{d.vehicle}</span></td>
              <td className="py-3 pr-4"><span className="text-sm font-semibold text-[#0F172A]">{d.trips}</span></td>
              <td className="py-3 pr-4">
                <div className="flex items-center gap-1">
                  <Icon name="StarIcon" size={13} variant="solid" className="text-yellow-400" />
                  <span className="text-sm font-medium text-[#0F172A]">{d.rating}</span>
                </div>
              </td>
              <td className="py-3">
                <span className={`chip text-[11px] font-semibold ${d.status === 'active' ? 'chip-green' : d.status === 'break' ? 'chip-orange' : 'text-[#64748B] bg-[#F5F5F5]'}`}>
                  {d.status === 'active' ? 'Active' : d.status === 'break' ? 'On Break' : 'Offline'}
                </span>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>);

}

function LiveMap() {
  return (
    <div className="map-placeholder h-72 relative overflow-hidden">
      <svg className="absolute inset-0 w-full h-full opacity-30" viewBox="0 0 400 288">
        <line x1="0" y1="144" x2="400" y2="144" stroke="#0066FF" strokeWidth="2" strokeDasharray="8,4" />
        <line x1="200" y1="0" x2="200" y2="288" stroke="#0066FF" strokeWidth="2" strokeDasharray="8,4" />
        <line x1="0" y1="72" x2="400" y2="72" stroke="#075DDF" strokeWidth="1" strokeDasharray="4,6" />
        <line x1="0" y1="216" x2="400" y2="216" stroke="#075DDF" strokeWidth="1" strokeDasharray="4,6" />
        <line x1="100" y1="0" x2="100" y2="288" stroke="#075DDF" strokeWidth="1" strokeDasharray="4,6" />
        <line x1="300" y1="0" x2="300" y2="288" stroke="#075DDF" strokeWidth="1" strokeDasharray="4,6" />
      </svg>
      {vehicleDots.map((pos, i) =>
      <div key={i} className="absolute" style={{ left: pos.x, top: pos.y, transform: 'translate(-50%, -50%)' }}>
          <div className="relative">
            <div className="w-4 h-4 rounded-full bg-[#0066FF] border-2 border-white shadow-md" />
            <div className="absolute inset-0 rounded-full bg-[#0066FF] opacity-30 animate-ping" style={{ animationDelay: `${i * 0.3}s` }} />
          </div>
        </div>
      )}
      <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-sm rounded-xl px-4 py-2 border border-[rgba(15,23,42,0.08)] shadow-sm">
        <div className="text-xs font-semibold text-[#0F172A]">Bangalore Metro</div>
        <div className="text-[10px] text-[#64748B]">38 vehicles tracked</div>
      </div>
    </div>);

}

export default function DashboardContent() {
  const [activeTab, setActiveTab] = useState<'overview' | 'trips' | 'fleet'>('overview');
  const [liveTime, setLiveTime] = useState('');

  useEffect(() => {
    const update = () => {
      const now = new Date();
      setLiveTime(now.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', second: '2-digit' }));
    };
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('is-visible');
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px -20px 0px' }
    );
    document.querySelectorAll('.animate-on-scroll').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [activeTab]);

  return (
    <div className="pt-20 bg-[#F5F5F5] min-h-screen">
      {/* Top bar */}
      <div className="sticky top-16 md:top-20 z-30 border-b border-[rgba(15,23,42,0.08)] bg-white/95 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-14">
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <span className="relative w-2 h-2 inline-flex">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
                </span>
                <span className="text-sm font-medium text-[#0F172A]">Live Dashboard</span>
              </div>
              <span className="text-xs font-mono-custom text-[#64748B] hidden sm:block">{liveTime} IST</span>
            </div>

            <div className="flex items-center gap-2">
              {(['overview', 'trips', 'fleet'] as const).map((tab) =>
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-4 py-1.5 rounded-lg text-sm font-medium capitalize transition-all duration-200 ${
                activeTab === tab ? 'text-white shadow-blue-sm' : 'text-[#475569] hover:bg-[#F5F5F5]'}`
                }
                style={activeTab === tab ? { background: 'linear-gradient(135deg, #0066FF, #075DDF)' } : {}}>
                  {tab}
                </button>
              )}
            </div>

            <div className="flex items-center gap-2">
              <button className="w-8 h-8 flex items-center justify-center rounded-lg text-[#475569] hover:bg-[#F5F5F5] transition-colors">
                <Icon name="BellIcon" size={18} />
              </button>
              <button className="w-8 h-8 flex items-center justify-center rounded-lg text-[#475569] hover:bg-[#F5F5F5] transition-colors">
                <Icon name="ArrowDownTrayIcon" size={18} />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

        {/* KPI Cards — always visible */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          {kpiCards.map((kpi, i) =>
          <div key={kpi.label} className={`animate-on-scroll stagger-${i + 1} dashboard-card p-6`}>
              <div className="flex items-start justify-between mb-4">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: `${kpi.color}18`, border: `1px solid ${kpi.color}25` }}>
                  <Icon name={kpi.icon as Parameters<typeof Icon>[0]['name']} size={20} style={{ color: kpi.color }} />
                </div>
                <span className={`chip text-xs font-semibold ${kpi.up ? 'chip-green' : 'chip-orange'}`}>
                  {kpi.up ? '↑' : '↓'} {kpi.change}
                </span>
              </div>
              <div className="font-display text-2xl font-semibold text-[#0F172A] leading-none mb-1">{kpi.value}</div>
              <div className="text-xs text-[#64748B] font-medium">{kpi.label}</div>
            </div>
          )}
        </div>

        {/* ── OVERVIEW TAB ── */}
        {activeTab === 'overview' &&
        <>
            <div className="grid lg:grid-cols-3 gap-6 mb-6">
              {/* Weekly trips area chart */}
              <div className="animate-on-scroll stagger-1 lg:col-span-2 dashboard-card p-6">
                <div className="flex items-center justify-between mb-6">
                  <div>
                    <h3 className="font-semibold text-[#0F172A]">Weekly Trip Volume</h3>
                    <p className="text-xs text-[#64748B] mt-0.5">Trips and revenue — last 7 days</p>
                  </div>
                  <span className="chip chip-blue">This Week</span>
                </div>
                <ResponsiveContainer width="100%" height={220}>
                  <AreaChart data={tripData} margin={{ top: 4, right: 4, left: -20, bottom: 0 }}>
                    <defs>
                      <linearGradient id="tripGrad" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor="#0066FF" stopOpacity={0.25} />
                        <stop offset="95%" stopColor="#0066FF" stopOpacity={0} />
                      </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" stroke="rgba(15,23,42,0.05)" />
                    <XAxis dataKey="day" tick={{ fontSize: 11, fill: '#94A3B8' }} axisLine={false} tickLine={false} />
                    <YAxis tick={{ fontSize: 11, fill: '#94A3B8' }} axisLine={false} tickLine={false} />
                    <Tooltip contentStyle={{ background: 'white', border: '1px solid rgba(15,23,42,0.08)', borderRadius: '12px', fontSize: '12px', boxShadow: '0 4px 24px -4px rgba(15,23,42,0.12)' }} />
                    <Area type="monotone" dataKey="trips" stroke="#0066FF" strokeWidth={2.5} fill="url(#tripGrad)" dot={{ r: 3, fill: '#0066FF', strokeWidth: 0 }} activeDot={{ r: 5, fill: '#0066FF' }} />
                  </AreaChart>
                </ResponsiveContainer>
              </div>

              {/* Pie */}
              <div className="animate-on-scroll stagger-2 dashboard-card p-6">
                <div className="mb-6">
                  <h3 className="font-semibold text-[#0F172A]">Trip Distribution</h3>
                  <p className="text-xs text-[#64748B] mt-0.5">By platform type</p>
                </div>
                <ResponsiveContainer width="100%" height={160}>
                  <PieChart>
                    <Pie data={pieData} cx="50%" cy="50%" innerRadius={48} outerRadius={72} paddingAngle={3} dataKey="value">
                      {pieData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} />)}
                    </Pie>
                    <Tooltip contentStyle={{ background: 'white', border: '1px solid rgba(15,23,42,0.08)', borderRadius: '10px', fontSize: '12px' }} />
                  </PieChart>
                </ResponsiveContainer>
                <div className="flex flex-col gap-2 mt-4">
                  {pieData.map((p) =>
                <div key={p.name} className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <div className="w-2.5 h-2.5 rounded-full" style={{ background: p.color }} />
                        <span className="text-xs text-[#475569] font-medium">{p.name}</span>
                      </div>
                      <span className="text-xs font-semibold text-[#0F172A]">{p.value}%</span>
                    </div>
                )}
                </div>
              </div>
            </div>

            <div className="grid lg:grid-cols-3 gap-6 mb-6">
              {/* Monthly bar chart */}
              <div className="animate-on-scroll stagger-1 lg:col-span-2 dashboard-card p-6">
                <div className="flex items-center justify-between mb-6">
                  <div>
                    <h3 className="font-semibold text-[#0F172A]">Monthly Growth</h3>
                    <p className="text-xs text-[#64748B] mt-0.5">Total trips per month</p>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <span className="relative w-1.5 h-1.5 inline-flex">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
                      <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-emerald-500" />
                    </span>
                    <span className="text-xs text-emerald-600 font-medium">+13.4% MoM</span>
                  </div>
                </div>
                <ResponsiveContainer width="100%" height={200}>
                  <BarChart data={monthlyData} margin={{ top: 4, right: 4, left: -20, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="rgba(15,23,42,0.05)" vertical={false} />
                    <XAxis dataKey="month" tick={{ fontSize: 11, fill: '#94A3B8' }} axisLine={false} tickLine={false} />
                    <YAxis tick={{ fontSize: 11, fill: '#94A3B8' }} axisLine={false} tickLine={false} tickFormatter={(v) => `${(v / 1000).toFixed(0)}K`} />
                    <Tooltip contentStyle={{ background: 'white', border: '1px solid rgba(15,23,42,0.08)', borderRadius: '12px', fontSize: '12px', boxShadow: '0 4px 24px -4px rgba(15,23,42,0.12)' }} formatter={(value: number) => [`${(value / 1000).toFixed(1)}K trips`, 'Volume']} />
                    <Bar dataKey="trips" radius={[6, 6, 0, 0]}>
                      {monthlyData.map((_, index) => <Cell key={`bar-${index}`} fill={index === monthlyData.length - 1 ? '#0066FF' : '#ECF3FE'} />)}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>

              {/* Fleet status */}
              <div className="animate-on-scroll stagger-2 dashboard-card p-6">
                <div className="mb-6">
                  <h3 className="font-semibold text-[#0F172A]">Fleet Status</h3>
                  <p className="text-xs text-[#64748B] mt-0.5">62 vehicles total</p>
                </div>
                <div className="flex flex-col gap-4">
                  {fleetStatus.map((s) =>
                <div key={s.label}>
                      <div className="flex items-center justify-between mb-1.5">
                        <div className="flex items-center gap-2">
                          <div className="w-2 h-2 rounded-full" style={{ background: s.color }} />
                          <span className="text-sm text-[#475569] font-medium">{s.label}</span>
                        </div>
                        <span className="text-sm font-semibold text-[#0F172A]">{s.count}</span>
                      </div>
                      <div className="w-full h-2 bg-[#F5F5F5] rounded-full overflow-hidden">
                        <div className="h-full rounded-full transition-all duration-700" style={{ width: `${s.count / 62 * 100}%`, background: s.color }} />
                      </div>
                    </div>
                )}
                </div>
                <div className="mt-6 pt-4 border-t border-[rgba(15,23,42,0.06)]">
                  <div className="text-center">
                    <div className="font-display text-3xl font-semibold text-gradient">61.3%</div>
                    <div className="text-xs text-[#64748B] font-medium mt-1">Fleet Utilization Rate</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Live Map + Live Trips */}
            <div className="grid lg:grid-cols-5 gap-6 mb-6">
              <div className="animate-on-scroll stagger-1 lg:col-span-3 dashboard-card overflow-hidden">
                <div className="p-5 border-b border-[rgba(15,23,42,0.06)] flex items-center justify-between">
                  <div>
                    <h3 className="font-semibold text-[#0F172A]">Live Fleet Map</h3>
                    <p className="text-xs text-[#64748B] mt-0.5">Bangalore, Karnataka</p>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <span className="relative w-1.5 h-1.5 inline-flex">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#0066FF] opacity-75" />
                      <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-[#0066FF]" />
                    </span>
                    <span className="text-xs text-[#0066FF] font-medium">38 active</span>
                  </div>
                </div>
                <LiveMap />
              </div>

              <div className="animate-on-scroll stagger-2 lg:col-span-2 dashboard-card p-6">
                <div className="flex items-center justify-between mb-5">
                  <div>
                    <h3 className="font-semibold text-[#0F172A]">Live Trips</h3>
                    <p className="text-xs text-[#64748B] mt-0.5">Active right now</p>
                  </div>
                  <span className="chip chip-blue">{liveTrips.length} active</span>
                </div>
                <div className="flex flex-col gap-3">
                  {liveTrips.map((trip) =>
                <div key={trip.id} className="p-4 bg-[#F5F5F5] rounded-xl border border-[rgba(15,23,42,0.06)] hover:border-[rgba(0, 102, 255,0.2)] transition-colors">
                      <div className="flex items-start justify-between mb-2">
                        <span className="font-mono-custom text-xs font-semibold text-[#0066FF]">{trip.id}</span>
                        <span className={`chip text-[10px] font-semibold ${trip.status === 'Arriving' ? 'chip-green' : 'chip-blue'}`}>{trip.status}</span>
                      </div>
                      <div className="flex items-center gap-1.5 text-xs text-[#475569] mb-1">
                        <Icon name="MapPinIcon" size={11} className="text-[#0066FF] flex-shrink-0" />
                        <span className="truncate">{trip.from}</span>
                        <Icon name="ArrowRightIcon" size={10} className="flex-shrink-0 text-[#64748B]" />
                        <span className="truncate">{trip.to}</span>
                      </div>
                      <div className="flex items-center justify-between mt-2">
                        <span className="text-[11px] text-[#64748B]">{trip.driver}</span>
                        <div className="flex items-center gap-1 text-[11px] font-medium text-[#0F172A]">
                          <Icon name="ClockIcon" size={11} className="text-[#64748B]" />
                          ETA {trip.eta}
                        </div>
                      </div>
                    </div>
                )}
                </div>
              </div>
            </div>

            {/* Driver leaderboard */}
            <div className="animate-on-scroll stagger-1 dashboard-card p-6 mb-6">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h3 className="font-semibold text-[#0F172A]">Driver Leaderboard</h3>
                  <p className="text-xs text-[#64748B] mt-0.5">Top performers today</p>
                </div>
                <button className="text-xs font-medium text-[#0066FF] hover:underline">View All</button>
              </div>
              <DriverTable />
            </div>
          </>
        }

        {/* ── TRIPS TAB ── */}
        {activeTab === 'trips' &&
        <>
            <div className="grid lg:grid-cols-2 gap-6 mb-6">
              {/* Live trips list */}
              <div className="animate-on-scroll stagger-1 dashboard-card p-6">
                <div className="flex items-center justify-between mb-5">
                  <div>
                    <h3 className="font-semibold text-[#0F172A]">Live Trips</h3>
                    <p className="text-xs text-[#64748B] mt-0.5">Active right now</p>
                  </div>
                  <span className="chip chip-blue">{liveTrips.length} active</span>
                </div>
                <div className="flex flex-col gap-3">
                  {liveTrips.map((trip) =>
                <div key={trip.id} className="p-4 bg-[#F5F5F5] rounded-xl border border-[rgba(15,23,42,0.06)] hover:border-[rgba(0, 102, 255,0.2)] transition-colors">
                      <div className="flex items-start justify-between mb-2">
                        <span className="font-mono-custom text-xs font-semibold text-[#0066FF]">{trip.id}</span>
                        <span className={`chip text-[10px] font-semibold ${trip.status === 'Arriving' ? 'chip-green' : 'chip-blue'}`}>{trip.status}</span>
                      </div>
                      <div className="flex items-center gap-1.5 text-xs text-[#475569] mb-1">
                        <Icon name="MapPinIcon" size={11} className="text-[#0066FF] flex-shrink-0" />
                        <span className="truncate">{trip.from}</span>
                        <Icon name="ArrowRightIcon" size={10} className="flex-shrink-0 text-[#64748B]" />
                        <span className="truncate">{trip.to}</span>
                      </div>
                      <div className="flex items-center justify-between mt-2">
                        <span className="text-[11px] text-[#64748B]">{trip.driver}</span>
                        <div className="flex items-center gap-1 text-[11px] font-medium text-[#0F172A]">
                          <Icon name="ClockIcon" size={11} className="text-[#64748B]" />
                          ETA {trip.eta}
                        </div>
                      </div>
                    </div>
                )}
                </div>
              </div>

              {/* Weekly trip chart */}
              <div className="animate-on-scroll stagger-2 dashboard-card p-6">
                <div className="flex items-center justify-between mb-6">
                  <div>
                    <h3 className="font-semibold text-[#0F172A]">Weekly Trip Volume</h3>
                    <p className="text-xs text-[#64748B] mt-0.5">Last 7 days</p>
                  </div>
                  <span className="chip chip-blue">This Week</span>
                </div>
                <ResponsiveContainer width="100%" height={220}>
                  <AreaChart data={tripData} margin={{ top: 4, right: 4, left: -20, bottom: 0 }}>
                    <defs>
                      <linearGradient id="tripGrad2" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor="#0066FF" stopOpacity={0.25} />
                        <stop offset="95%" stopColor="#0066FF" stopOpacity={0} />
                      </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" stroke="rgba(15,23,42,0.05)" />
                    <XAxis dataKey="day" tick={{ fontSize: 11, fill: '#94A3B8' }} axisLine={false} tickLine={false} />
                    <YAxis tick={{ fontSize: 11, fill: '#94A3B8' }} axisLine={false} tickLine={false} />
                    <Tooltip contentStyle={{ background: 'white', border: '1px solid rgba(15,23,42,0.08)', borderRadius: '12px', fontSize: '12px' }} />
                    <Area type="monotone" dataKey="trips" stroke="#0066FF" strokeWidth={2.5} fill="url(#tripGrad2)" dot={{ r: 3, fill: '#0066FF', strokeWidth: 0 }} activeDot={{ r: 5, fill: '#0066FF' }} />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
            </div>

            <div className="grid lg:grid-cols-2 gap-6 mb-6">
              {/* Trip distribution */}
              <div className="animate-on-scroll stagger-1 dashboard-card p-6">
                <div className="mb-6">
                  <h3 className="font-semibold text-[#0F172A]">Trip Distribution</h3>
                  <p className="text-xs text-[#64748B] mt-0.5">By platform type</p>
                </div>
                <ResponsiveContainer width="100%" height={160}>
                  <PieChart>
                    <Pie data={pieData} cx="50%" cy="50%" innerRadius={48} outerRadius={72} paddingAngle={3} dataKey="value">
                      {pieData.map((entry, index) => <Cell key={`cell-t-${index}`} fill={entry.color} />)}
                    </Pie>
                    <Tooltip contentStyle={{ background: 'white', border: '1px solid rgba(15,23,42,0.08)', borderRadius: '10px', fontSize: '12px' }} />
                  </PieChart>
                </ResponsiveContainer>
                <div className="flex flex-col gap-2 mt-4">
                  {pieData.map((p) =>
                <div key={p.name} className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <div className="w-2.5 h-2.5 rounded-full" style={{ background: p.color }} />
                        <span className="text-xs text-[#475569] font-medium">{p.name}</span>
                      </div>
                      <span className="text-xs font-semibold text-[#0F172A]">{p.value}%</span>
                    </div>
                )}
                </div>
              </div>

              {/* Monthly growth */}
              <div className="animate-on-scroll stagger-2 dashboard-card p-6">
                <div className="flex items-center justify-between mb-6">
                  <div>
                    <h3 className="font-semibold text-[#0F172A]">Monthly Growth</h3>
                    <p className="text-xs text-[#64748B] mt-0.5">Total trips per month</p>
                  </div>
                  <span className="text-xs text-emerald-600 font-medium">+13.4% MoM</span>
                </div>
                <ResponsiveContainer width="100%" height={200}>
                  <BarChart data={monthlyData} margin={{ top: 4, right: 4, left: -20, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="rgba(15,23,42,0.05)" vertical={false} />
                    <XAxis dataKey="month" tick={{ fontSize: 11, fill: '#94A3B8' }} axisLine={false} tickLine={false} />
                    <YAxis tick={{ fontSize: 11, fill: '#94A3B8' }} axisLine={false} tickLine={false} tickFormatter={(v) => `${(v / 1000).toFixed(0)}K`} />
                    <Tooltip contentStyle={{ background: 'white', border: '1px solid rgba(15,23,42,0.08)', borderRadius: '12px', fontSize: '12px' }} formatter={(value: number) => [`${(value / 1000).toFixed(1)}K trips`, 'Volume']} />
                    <Bar dataKey="trips" radius={[6, 6, 0, 0]}>
                      {monthlyData.map((_, index) => <Cell key={`bar-t-${index}`} fill={index === monthlyData.length - 1 ? '#0066FF' : '#ECF3FE'} />)}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>

            {/* Driver leaderboard */}
            <div className="animate-on-scroll stagger-1 dashboard-card p-6 mb-6">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h3 className="font-semibold text-[#0F172A]">Driver Leaderboard</h3>
                  <p className="text-xs text-[#64748B] mt-0.5">Top performers today</p>
                </div>
                <button className="text-xs font-medium text-[#0066FF] hover:underline">View All</button>
              </div>
              <DriverTable />
            </div>
          </>
        }

        {/* ── FLEET TAB ── */}
        {activeTab === 'fleet' &&
        <>
            {/* Fleet status summary cards */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
              {fleetStatus.map((s, i) =>
            <div key={s.label} className={`animate-on-scroll stagger-${i + 1} dashboard-card p-6`}>
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center mb-4" style={{ background: s.bg, border: `1px solid ${s.color}30` }}>
                    <Icon name="TruckIcon" size={20} style={{ color: s.color }} />
                  </div>
                  <div className="font-display text-3xl font-semibold text-[#0F172A] leading-none mb-1">{s.count}</div>
                  <div className="text-xs text-[#64748B] font-medium">{s.label}</div>
                </div>
            )}
            </div>

            <div className="grid lg:grid-cols-3 gap-6 mb-6">
              {/* Fleet status breakdown */}
              <div className="animate-on-scroll stagger-1 dashboard-card p-6">
                <div className="mb-6">
                  <h3 className="font-semibold text-[#0F172A]">Fleet Status Breakdown</h3>
                  <p className="text-xs text-[#64748B] mt-0.5">62 vehicles total</p>
                </div>
                <div className="flex flex-col gap-4">
                  {fleetStatus.map((s) =>
                <div key={s.label}>
                      <div className="flex items-center justify-between mb-1.5">
                        <div className="flex items-center gap-2">
                          <div className="w-2 h-2 rounded-full" style={{ background: s.color }} />
                          <span className="text-sm text-[#475569] font-medium">{s.label}</span>
                        </div>
                        <span className="text-sm font-semibold text-[#0F172A]">{s.count}</span>
                      </div>
                      <div className="w-full h-2 bg-[#F5F5F5] rounded-full overflow-hidden">
                        <div className="h-full rounded-full transition-all duration-700" style={{ width: `${s.count / 62 * 100}%`, background: s.color }} />
                      </div>
                    </div>
                )}
                </div>
                <div className="mt-6 pt-4 border-t border-[rgba(15,23,42,0.06)]">
                  <div className="text-center">
                    <div className="font-display text-3xl font-semibold text-gradient">61.3%</div>
                    <div className="text-xs text-[#64748B] font-medium mt-1">Fleet Utilization Rate</div>
                  </div>
                </div>
              </div>

              {/* Live map */}
              <div className="animate-on-scroll stagger-2 lg:col-span-2 dashboard-card overflow-hidden">
                <div className="p-5 border-b border-[rgba(15,23,42,0.06)] flex items-center justify-between">
                  <div>
                    <h3 className="font-semibold text-[#0F172A]">Live Fleet Map</h3>
                    <p className="text-xs text-[#64748B] mt-0.5">Bangalore, Karnataka</p>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <span className="relative w-1.5 h-1.5 inline-flex">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#0066FF] opacity-75" />
                      <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-[#0066FF]" />
                    </span>
                    <span className="text-xs text-[#0066FF] font-medium">38 active</span>
                  </div>
                </div>
                <LiveMap />
              </div>
            </div>

            {/* Driver & vehicle assignment */}
            <div className="animate-on-scroll stagger-1 dashboard-card p-6 mb-6">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h3 className="font-semibold text-[#0F172A]">Driver & Vehicle Assignment</h3>
                  <p className="text-xs text-[#64748B] mt-0.5">Current fleet assignments</p>
                </div>
                <button className="text-xs font-medium text-[#0066FF] hover:underline">Manage Fleet</button>
              </div>
              <DriverTable />
            </div>
          </>
        }

        {/* Bottom disclaimer */}
        <div className="animate-on-scroll stagger-1 text-center py-6">
          <div className="inline-flex items-center gap-2 px-4 py-2.5 bg-white rounded-xl border border-[rgba(15,23,42,0.07)] shadow-sm">
            <Icon name="InformationCircleIcon" size={16} className="text-[#0066FF]" />
            <span className="text-xs text-[#64748B]">
              This is a preview dashboard with sample data. Real data connects via your Movio account.
            </span>
          </div>
        </div>
      </div>
    </div>);

}